<mat-sidenav-container class="application-container">
  <mat-sidenav mode="side" opened [ngClass]="(externalApplication) ? 'external' : ''">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <p><strong>Progress</strong></p>

          <mat-progress-bar
            [color]="'primary'"
            [mode]="'determinate'"
            [value]="(latestStep*100)/(steps.length-1)">
          </mat-progress-bar>

          <div class="mt-2">
            <small *ngIf="baseform">
              <a style="cursor: pointer" [hidden]="loading" (click)="resetForm()" tabindex="-1">Clear data</a>
            </small>
          </div>

          <!-- don't include the comfirmation step in length -->
          <mat-list>
            <div (click)="navigateToStep(i)" *ngFor="let step of steps;let i = index;">
              <mat-list-item *ngIf="showStep(step)" class="white-link {{step.classNameStatus}}">
                {{step.name}}<i class="material-icons md-18 icon-position-right">{{getStepIcon(i)}}</i>
              </mat-list-item>
            </div>
          </mat-list>

          <button *ngIf="activeStep > 0 && !applicationSubmitted" mat-raised-button color="primary"
                  class="fmc-button-primary mt-4" type="button" (click)="savePartial(true)">Save application
          </button>
        </div>
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content id="contentBody" [ngClass]="(externalApplication) ? 'external' : ''">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-10">
          <h2>{{wizardName}}</h2>
        </div>
        <div class="col-sm-2 text-end">
          <!-- <button mat-raised-button color="'primary'" [disabled]="loading" type="button" (click)="resetForm()">Reset Form</button> -->
        </div>
      </div>
      <ng-container *ngIf="baseform">
        <form (ngSubmit)="submitApplication()" #form="ngForm" class="form__wizard" autocapitalize="off"
              autocomplete="off" autocorrect="off" spellcheck="false" novalidate>
          <div *ngFor="let step of steps;let stepIdx = index; let isLastStep=last;"
               class="application-step form__wizard--step" [ngClass]="[activeStep === stepIdx ? 'active' : '']">
            <div class="row">

              <div [ngClass]="widget.class" *ngFor="let widget of step.widgets">
                <app-originator-broker
                  *ngIf="widget.name === 'app-originator-broker'"
                  [opts]="widget.opts"
                  [productCategory]="loanPurposeType"
                  [isHomeLoan]="isHomeLoan"
                  [isFurtherAdvance]="isFurtherAdvance"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  (brokerDetails)="handleBrokerDetailsChange($event)"
                  (originatorDetails)="handleOriginatorDetailsChange($event)"
                ></app-originator-broker>

                <app-customer-details
                  *ngIf="widget.name === 'app-customer-details'"
                  [opts]="widget.opts"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  (customerDetailsChange)="handleCustomerDetails($event)"
                ></app-customer-details>

                <app-abn-acn
                  *ngIf="widget.name === 'app-abn-acn'"
                  [opts]="widget.opts"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                ></app-abn-acn>

                <app-borrower-type
                  *ngIf="widget.name === 'app-borrower-type' && !savedAppsDisplayed"
                  [opts]="widget.opts"
                  [isLateInit]="isLateInit"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  [personList]="personalDetails"
                  [selectedCompany]="selectedCompany"
                  (borrowingTypeChange)="handleBorrowingTypeChange($event)"
                ></app-borrower-type>

                <app-borrower-type-enhanced
                  *ngIf="widget.name === 'app-borrower-type-enhanced' && !savedAppsDisplayed"
                  [isSMSF]="isSMSF"
                  [opts]="widget.opts"
                  [isLateInit]="isLateInit"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  [applicationType]="applicationType"
                  [personList]="personalDetails"
                  [companyList]="companyDetails"
                  [trustList]="trustDetails"
                  [isFurtherAdvance]="isFurtherAdvance"
                  (checkNonApplicantValidation)="checkNonApplicantValidation = true"
                  (borrowingTypeChange)="handleBorrowingTypeChange($event)"
                ></app-borrower-type-enhanced>

                <app-borrower-type-enhanced
                  *ngIf="widget.name === 'app-borrower-type-enhanced-smsf' && isSMSF && !savedAppsDisplayed"
                  [isSMSF]="isSMSF"
                  [opts]="widget.opts"
                  [isLateInit]="isLateInit"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  [applicationType]="'new-trust'"
                  [personList]="personalDetails"
                  [companyList]="companyDetails"
                  [trustList]="trustDetails"
                  [isFurtherAdvance]="isFurtherAdvance"
                  (borrowingTypeChange)="handleBorrowingTypeChange($event)"
                  [isSMSFPanel]=true
                ></app-borrower-type-enhanced>

                <app-trust-details
                  *ngIf="widget.name === 'app-trust-details'"
                  [opts]="widget.opts"
                  [personList]="personalDetails"
                  [companyList]="companyDetails"
                  [formGroup]="trustDetails"
                  [borrowerType]="borrowerType"
                ></app-trust-details>

                <app-company-details
                  *ngIf="widget.name === 'app-company-details'"
                  [opts]="widget.opts"
                  [personList]="personalDetails"
                  [trustList]="trustDetails"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  [borrowerType]="borrowerType"
                ></app-company-details>

                <app-personal-details
                  *ngIf="widget.name === 'app-personal-details'"
                  [opts]="widget.opts"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  [isHomeLoan]="isHomeLoan"
                  [personList]="personalDetails"
                  [companyList]="companyDetails"
                  [isSmsf]="isSMSF"
                  [trustList]="trustDetails"
                  [applicationType]="applicationType"
                  [borrowerType]="borrowerType"
                  [brokerDetails]="brokerDetails"
                  [checkNonApplicantValidation]="checkNonApplicantValidation"
                  [borrowerCount]="borrowerCount"
                  [isFurtherAdvance]="isFurtherAdvance"
                ></app-personal-details>

                <app-business-car-loan-details
                  *ngIf="widget.name === 'app-business-car-loan-details'"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                ></app-business-car-loan-details>

                <app-loan-details
                  *ngIf="widget.name === 'app-loan-details'"
                  [opts]="widget.opts"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  [brokerDetails]="brokerDetails"
                  [loanPurposeType]="loanPurposeType"
                  [selectedLoanDescription]="selectedLoanDescription"
                  (loanProductTypeChange)="handleLoanProductTypeChange($event)"
                  (loanPurposeChange)="handleLoanPurposeChange($event)"
                  (loanInsuranceList)="handledInsuranceList($event)"
                ></app-loan-details>

                <app-single-split-loan-amount
                  *ngIf="widget.name === 'app-single-split-loan-amount'"
                  [opts]="widget.opts"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  [originator]="originatorDetails"
                  [insuranceList]="insuranceList"
                  [hasSettlement]="hasSettlement"
                  [isGreen]="isGreen"
                  [minLoanAmountDisabled]="minLoanAmountDisabled"
                  [selectedVehicle]="selectedVehicle"
                  [loanPurpose]="selectedLoanPurpose"
                  [loanProduct]="selectedLoanProduct"
                  [productCategory]="loanPurposeType"
                  [originationFeeValidationSwitch]="originationFeeValidationSwitch"
                  (purchaseAmountChange)="handlePurchaseAmountChange($event)"
                ></app-single-split-loan-amount>

                <app-loan-terms
                  *ngIf="widget.name === 'app-loan-terms'"
                  [opts]="widget.opts"
                  [selectedLoanProductType]="selectedLoanProductType"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  (loanTermChange)="handleLoanTermChange($event)"
                ></app-loan-terms>

                <app-balloon-amount
                  *ngIf="widget.name === 'app-balloon-amount'"
                  [opts]="widget.opts"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  [loanPurposeType]="loanPurposeType"
                  [currentPurchaseAmount]="currentPurchaseAmount"
                  [loanPurpose]="selectedLoanPurpose"
                  [loanTerm]="loanTerm"
                  [autoCollateral]="selectedLoanDescription"
                  [selectedVehicle]="selectedVehicle"
                ></app-balloon-amount>

                <app-employment-details
                  *ngIf="widget.name === 'app-employment-details'"
                  [opts]="widget.opts"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  [personList]="personalDetails"
                  [isSMSF]="isSMSF"
                  [isInternalUser]="isInternalUser"
                  [applicationType]="applicationType"
                  [productCategory]="loanPurposeType"
                  [isFurtherAdvance]="isFurtherAdvance"
                ></app-employment-details>

                <app-investment-income
                  id="app-investment-income"
                  *ngIf="widget.name === 'app-investment-income'"
                  [opts]="widget.opts"
                  [isSMSF]="isSMSF"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  [personList]="personalDetails"
                  [companyList]="companyDetails"
                  [trustList]="trustDetails"
                  [isFurtherAdvance]="isFurtherAdvance"
                ></app-investment-income>

                <app-income-details
                  *ngIf="widget.name === 'app-income-details'"
                  [opts]="widget.opts"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  [personList]="personalDetails"
                  [companyList]="companyDetails"
                  [trustList]="trustDetails"
                ></app-income-details>

                <app-assets-details
                  *ngIf="widget.name === 'app-assets-details'"
                  [opts]="widget.opts"
                  [navigator]="navigatorSubject"
                  [investmentFormArray]="investmentFormArray"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  [personList]="personalDetails"
                  [companyList]="companyDetails"
                  [trustList]="trustDetails"
                  [isSMSF]="isSMSF"
                  [isFurtherAdvance]="isFurtherAdvance"
                ></app-assets-details>

                <app-liabilities-details
                  *ngIf="widget.name === 'app-liabilities-details' && !isSMSF"
                  [opts]="widget.opts"
                  [navigator]="navigatorSubject"
                  [personList]="personalDetails"
                  [investmentFormArray]="investmentFormArray"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  [companyList]="companyDetails"
                  [trustList]="trustDetails"
                  [isSMSF]="isSMSF"
                  [isFurtherAdvance]="isFurtherAdvance"
                ></app-liabilities-details>

                <app-expenses-details
                  *ngIf="widget.name === 'app-expenses-details' && !isSMSF"
                  [opts]="widget.opts"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  [isFurtherAdvance]="isFurtherAdvance"
                ></app-expenses-details>

                <app-auto-collateral
                  *ngIf="widget.name === 'app-auto-collateral'"
                  [opts]="widget.opts"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  (autoCollateralChange)="handleLoanDescriptionChange($event)"
                ></app-auto-collateral>

                <app-docs-upload
                  *ngIf="widget.name === 'app-docs-upload'"
                  [opts]="widget.opts"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  [isHomeLoan]="isHomeLoan"
                  [personList]="personalDetails"
                  [companyList]="companyDetails"
                  [trustList]="trustDetails"
                  [securityDetails]="securityDetails"
                  [step]="step"
                  [activeStep]="activeStep"
                ></app-docs-upload>

              <app-submit
                *ngIf="widget.name === 'app-submit'"
                [personList]="personalDetails"
                [isInternalUser]="isInternalUser"
                [baseform]="baseform"
                [isHomeLoan]="isHomeLoan"
                [loanPurposeType]="loanPurposeType"
                [storageIdentifier]="storageIdentifier"
                [salesRelatesTo]="salesRelatesTo"
                [activeStep]="activeStep"
                [steps]="steps"
                [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                [generalContent]="getGeneralBlurb()"
                [ndiTrustCompanyResultsDisabled]="ndiTrustCompanyResultsDisabled"
                [applicationType]="applicationType"
              ></app-submit>

                <app-confirmation
                  *ngIf="widget.name === 'app-confirmation'"
                  [applicationData]="applicationData"
                  [baseform]="baseform"
                  [storageIdentifier]="storageIdentifier"
                ></app-confirmation>

                <app-quote-details
                  *ngIf="widget.name === 'app-quote-details'"
                  [opts]="widget.opts"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  [broker]="brokerDetails"
                  [loanProduct]="selectedLoanProduct"
                  [featureSwitches]="featureSwitches"
                  (loanInsuranceList)="handledInsuranceList($event)"
                  (loanProductTypeChange)="handleLoanProductTypeChange($event)"
                  (loanPurposeChange)="handleLoanPurposeChange($event)"
                  (autoCollateralChange)="handleLoanDescriptionChange($event)"
                ></app-quote-details>

                <app-quotes-list
                  *ngIf="widget.name === 'app-quotes-list'"
                  [opts]="widget.opts"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  [broker]="brokerDetails"
                ></app-quotes-list>

                <app-loan-details-terms
                  *ngIf="widget.name === 'app-loan-details-terms'"
                  [opts]="widget.opts"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  [brokerDetails]="brokerDetails"
                  [originatorDetails]="originatorDetails"
                  [loanPurposeType]="loanPurposeType"
                  [isGreen]="isGreen"
                  [featureSwitches]="featureSwitches"
                  [currentPurchaseAmount]="currentPurchaseAmount"
                  [storageIdentifier]="storageIdentifier"
                  [caravanDisabled]="caravanDisabled"
                  [isInternalUser]="isInternalUser"
                  (loanInsuranceList)="handledInsuranceList($event)"
                  (selectedVehicle)="handleVehicleChange($event)"
                  (emitInterestType)="handleInterestType($event)"
                  (emitGreen)="handleIsGreen($event)"
                  (loanPurpose)="handleLoanPurposeChange($event)"
                  (loanProduct)="handleLoanProductChange($event)"
                ></app-loan-details-terms>

                <!-- home loans -->
                <app-application-type
                  *ngIf="widget.name === 'app-application-type'"
                  [opts]="widget.opts"
                  [baseFormGroup]="baseform"
                  [baseModel]="baseModel"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  [originatorBrokers]="getWidget('app-originator-broker')"
                  [wizType]="storageIdentifier"
                  [isInternalUser]="isInternalUser"
                  [isFurtherAdvance]="isFurtherAdvance"
                  (applicationTypeChange)="handleApplicationTypeChange($event)"
                  (savedApplicationsDisplayed)="toggleSavedAppsList($event)"
                  (furtherAdvanceLoaded)="reInitializeForm($event)"
                ></app-application-type>

                <app-home-loan-details
                  *ngIf="widget.name === 'app-home-loan-details'"
                  [opts]="widget.opts"
                  [isSMSF]="isSMSF"
                  [securityDetails]="securityDetails"
                  [personalDetails]="personalDetails"
                  [companyDetails]="companyDetails"
                  [trustDetails]="trustDetails"
                  [tbaAddress]="setTbaAddress"
                  [isFurtherAdvance]="isFurtherAdvance"
                  [faParentAppId]="faParentAppId"
                  [faType]="faType"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  [applicationType]="applicationType"
                ></app-home-loan-details>

                <app-security-details
                  *ngIf="widget.name === 'app-security-details'"
                  [applicationType]="applicationType"
                  [opts]="widget.opts"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  [personList]="personalDetails"
                  [companyList]="companyDetails"
                  [trustList]="trustDetails"
                  [securityModel]="baseModel['step-'+stepIdx][widget.name]"
                  [isSMSF]="isSMSF"
                  [isInternalUser]="isInternalUser"
                  [originator]="getWidget('app-originator-broker').get('originator')"
                  [broker]="getWidget('app-originator-broker').get('broker')"
                  [borrowerType]="getWidget('app-borrower-type-enhanced').get('borrowerType')"
                  [isFurtherAdvance]="isFurtherAdvance"
                  [faType]="faType"
                  (securityDetails)="handleSecurityDetailsChange($event)"
                  (emitTbaAddress)="setTbaAddress = $event"
                ></app-security-details>

                <app-solicitor-panel-details
                  *ngIf="widget.name === 'app-solicitor-panel-details'"
                  [opts]="widget.opts"
                  [originatorDetails]="originatorDetails"
                  [securityDetails]="securityDetails"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                ></app-solicitor-panel-details>

                <app-solicitor-borrower-details
                  *ngIf="widget.name === 'app-solicitor-borrower-details'"
                  [opts]="widget.opts"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                ></app-solicitor-borrower-details>

                <app-rate
                  *ngIf="widget.name === 'app-rate'"
                  [opts]="widget.opts"
                  [originator]="originatorDetails"
                  [bidCompliance]="bidCompliance"
                  [baseform]="baseform"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                ></app-rate>

                <app-product
                  *ngIf="widget.name === 'app-product'"
                  [applicationType]="applicationType"
                  [opts]="widget.opts"
                  [isFurtherAdvance]="isFurtherAdvance"
                  [faType]="faType"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                ></app-product>

                <app-broker-notes
                  *ngIf="widget.name === 'app-broker-notes'"
                  [opts]="widget.opts"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                ></app-broker-notes>
              </div>
            </div>
            <div class="row" *ngIf="!savedAppsDisplayed">
              <div class="col-sm-6 text-left">
                <button *ngIf="stepIdx !== 0 && !isLastStep" mat-raised-button color="'primary'" type="button"
                        (click)="progressPrevStep(steps[stepIdx-1])">Back
                </button>
              </div>
              <div class="col-sm-6 text-end">
                <button *ngIf="stepIdx < steps.length-2" mat-raised-button color="'primary'" class="fmc-button-primary"
                        type="button" (click)="progressNextStep(steps[stepIdx+1])">Next
                </button>
                <button *ngIf="stepIdx === steps.length-2" mat-raised-button color="'primary'" [ngClass]="!submitDisabled ? 'fmc-button-primary' : ''" type="submit" [disabled]="submitDisabled">
                  <mat-spinner *ngIf="isLoading" diameter="30" strokeWidth="3" mode="indeterminate"></mat-spinner>
                  <span *ngIf="!isLoading && !applicationSubmitted">Submit</span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </ng-container>

      <ng-container *ngIf="loading">
        <mat-progress-bar
          [color]="'primary'"
          [mode]="'indeterminate'">
        </mat-progress-bar>
      </ng-container>

    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
